var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPlusCircleDark = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(-50 -28)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M64.844 28C56.657 28 50 34.657 50 42.844s6.657 14.843 14.844 14.843 14.844-6.656 14.844-14.843C79.688 34.657 73.03 28 64.844 28zm6.125 16.468h-4.5v4.47c0 .905-.72 1.624-1.625 1.624-.906 0-1.625-.719-1.625-1.624v-4.47h-4.5c-.906 0-1.625-.719-1.625-1.624 0-.906.719-1.625 1.625-1.625h4.469v-4.5c0-.906.719-1.625 1.624-1.625.906 0 1.625.719 1.625 1.624v4.47h4.47c.905 0 1.624.718 1.624 1.624.001.907-.656 1.657-1.561 1.657z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlusCircleDark, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/plus-circle-dark.a55e720e.svg";
export { ForwardRef as ReactComponent };